const passos = [
  {
    numero: '01',
    titulo: 'Entendimento',
    descricao: 'Entendemos empresa, quantidade de pessoas, ambientes, cidade, prazo e necessidade.',
  },
  {
    numero: '02',
    titulo: 'Análise',
    descricao: 'Recebemos planta, medidas, fotos ou projeto do arquiteto.',
  },
  {
    numero: '03',
    titulo: 'Solução',
    descricao: 'Selecionamos mobiliário, divisórias e demais componentes adequados.',
  },
  {
    numero: '04',
    titulo: 'Proposta',
    descricao: 'Estruturamos proposta comercial e escopo.',
  },
  {
    numero: '05',
    titulo: 'Entrega e montagem',
    descricao: 'Coordenamos fornecimento, logística e implantação.',
  },
];

export default function ComoFuncionaSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-12 md:mb-16">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Como funciona
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Do primeiro contato ao ambiente pronto.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-5">
          {passos.map((passo) => (
            <div
              key={passo.numero}
              className="relative bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-7"
            >
              <span className="text-primary-500 text-[28px] md:text-[32px] font-semibold tracking-tight leading-none block mb-5">
                {passo.numero}
              </span>
              <h3 className="text-foreground-950 text-[16px] md:text-[17px] font-semibold tracking-tight mb-2">
                {passo.titulo}
              </h3>
              <p className="text-foreground-500 text-[13px] md:text-[14px] leading-relaxed">
                {passo.descricao}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}